import { GroupingState } from './state';
import { Action } from 'redux';

export const CHANGE_GROUPBY = 'CHANGE_GROUPBY';
export const COLLAPSE_GROUPBY = 'COLLAPSE_GROUPBY';

export type ChangeGroupBy = {
    type: typeof CHANGE_GROUPBY;
    payload: GroupingState;
};
export type CollapseGroupBy = Action<typeof COLLAPSE_GROUPBY>;

export type GroupingAction = ChangeGroupBy | CollapseGroupBy;
